const boundFunctions = new Map();

export default {
    bind(el, binding, vnode) {
        const showConfirmUpgrade = e => {
            if (!binding.value) {
                return;
            }

            e.preventDefault();

            const params = typeof binding.value === 'object' ? binding.value : {};
            vnode.context.showPopup('confirmUpgrade', {
                price: params.price || null,
                url: params.url || el.getAttribute('href'),
            });
        };

        el.addEventListener(binding.arg || 'click', showConfirmUpgrade);
        boundFunctions.set(el, showConfirmUpgrade);
    },

    unbind(el, binding) {
        if (boundFunctions.has(el)) {
            el.removeEventListener(binding.arg || 'click', boundFunctions.get(el));
            boundFunctions.delete(el);
        }
    }
}
